import { trimZ } from '../trimz';

export const getDate = (date: string | undefined, shouldTrimz: boolean = false): Date | undefined => {
  if (shouldTrimz) return date && date !== '' ? new Date(trimZ(date)) : undefined;

  return date && date !== '' ? new Date(date) : undefined;
};
